import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75d9af0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "round button-trans"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "round button-greeny"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "spinner-border",
  role: "status"
}
const _hoisted_8 = ["src"]

import {ref, watch} from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  image: {
    type: Object,
    required: true,
    default() {
      return {}
    }
  },
  selectionMode: {
    type: Boolean,
    default: false,
  },
  selection: {
    type: Array,
    required: true,
    default() {
      return []
    }
  }
},
  emits: ["imageSelected", "imageUnselected", "tooManyImagesSelected"],
  setup(__props, { emit }: { emit: ({
  (e: 'imageSelected', val: number):void
  (e: 'imageUnselected', val:number):void
  (e: 'tooManyImagesSelected'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const correctDimensions = () => {
  if (props.image.ratio >= 1) {
    domimage.value!.style.height = (domimage.value!.clientWidth/props.image.ratio) + 'px'
  }
}

const domimage = ref<HTMLDivElement>()

const selected = ref<boolean>(false)

const imageURI = ref<string>()
const status = ref<number>(0)

const loadImage = (uri:string) => {
  const img = new Image()
  img.onload = () => {
    imageURI.value = img.src
    status.value = 2
  }
  status.value = 1
  img.src = uri
}

// clear if selection is cleared
watch(() => props.selection, (value, oldValue) => {
  if (oldValue.length > 0 && value?.length === 0) {
    selected.value = false
  }
})

const selectionChange = () => {
  if (!props.selectionMode) {
    return
  }

  if (selected.value === true) {
    selected.value = false
    emit("imageUnselected", props.image.timestamp)
    return
  }

  if (props.selection.length >= 3) {
    emit('tooManyImagesSelected')
    return
  }

  if (selected.value === false) {
    selected.value = true
    emit("imageSelected", props.image.timestamp)
    return
  }
}

const avoidDrag = (e:Event) => e.preventDefault()

loadImage(props.image.thumbHref)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container-preview-image justify-content-end d-flex w-100", {'selectable': __props.selectionMode && status.value}]),
    onClick: selectionChange,
    style: {"padding":"0.75rem"}
  }, [
    (__props.selectionMode && status.value === 2)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "container-image-selection align-items-start",
          ref: (_value, _refs) => {
            _refs['container'] = _value
          }
        }, [
          (!selected.value)
            ? (_openBlock(), _createElementBlock("button", _hoisted_1, _hoisted_3))
            : (_openBlock(), _createElementBlock("button", _hoisted_4, _hoisted_6))
        ], 512))
      : _createCommentVNode("", true),
    (status.value === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : _createCommentVNode("", true),
    (status.value === 2)
      ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          ref: (_value, _refs) => {
            _refs['domimage'] = _value
            domimage.value = _value
          },
          src: imageURI.value,
          class: "preview-image",
          alt: "Image",
          loading: "lazy",
          onload: correctDimensions,
          ondragstart: avoidDrag
        }, null, 8, _hoisted_8))
      : _createCommentVNode("", true)
  ], 2))
}
}

})